'use client'
import { usePathname, useSearchParams } from 'next/navigation'
import {
  Configure,
  Hits,
  InstantSearch,
  Pagination,
  useHits,
  useInstantSearch,
} from 'react-instantsearch'
import { searchClient } from './typesenseAdapter'
import getRouting from './routing'
import Filters from './filters'
import FilterLabels from './filtersLabels'
import AdvancedSearch from '@/components/advanced-search/advancedSearch'
import { titleAndText } from './ArrayOftitleAndText'
import Image from 'next/image'
import { useEffect, useState } from 'react'
interface IProps {
  filterBy?: string
  filterToExclude?: string
}
const SearchResults = ({ filterBy, filterToExclude }: IProps) => {
  const indexName = 'individuals'
  const url = usePathname()
  const title: string = url.replace('/', '')
  const searchFromUrl = useSearchParams().get('query') || ''
  let query
  if (typeof document !== 'undefined' && url === '/advancedSearch') {
    const searchBox = (document.getElementById('search') as HTMLInputElement)?.value
    query = searchBox || searchFromUrl
    if (!searchBox) {
      ;(document.getElementById('search') as HTMLInputElement).value = searchFromUrl
    }
  }

  return (
    <InstantSearch
      indexName={indexName}
      searchClient={searchClient}
      routing={getRouting(indexName, query)}
    >
      <Configure
        hitsPerPage={25}
        filters={`published:true ${filterBy ? filterBy : ''}`}
        query={query || undefined}
      />
      <div className="">
        <div className="p-4 PageInternalContainer">
          {url != '/Canada' && url != '/medical' && (
            <h1 className="font-extrabold text-4xl">{titleAndText?.[title]?.title}</h1>
          )}
          <h2 className="font-semibold">{titleAndText?.[title]?.text}</h2>
          <div className={` max-w-[565px]`}>
            <Filters filterToExclude={filterToExclude} />
          </div>
          <div className="mb-[10px]">
            <FilterLabels />
          </div>
          <div className="min-h-[100vh]">
            <Results />
          </div>
          <Pagination
            showFirst={false}
            showLast={false}
            padding={1}
            classNames={{
              root: 'mt-4 flex flex-row justify-center',
              list: 'flex flex-row border border-gray-300  rounded	',
              item: ' h-[40px] w-[40px] flex items-center text-base	justify-center text-gray-600 hover:!text-[#1A56DB]',
              link: 'text-base h-[40px] w-[40px] flex items-center text-base	justify-center',
              selectedItem: 'bg-[#E1EFFE] !text-[#1A56DB]',
              pageItem: 'border-l border-gray-300',
              nextPageItem: 'border-l border-gray-300',
            }}
          />
        </div>
      </div>
    </InstantSearch>
  )
}

export default SearchResults

function NoResults() {
  return <p>No Results</p>
}

function Results() {
  const { hits } = useHits()
  const { status } = useInstantSearch()
  const [showNoResults, setShowNoResults] = useState(false)

  useEffect(() => {
    if (status === 'idle' && hits.length === 0) {
      const timer = setTimeout(() => setShowNoResults(true), 10)
      return () => clearTimeout(timer)
    } else {
      setShowNoResults(false)
    }
  }, [status, hits])

  if (status !== 'idle') {
    return (
      <div className="flex justify-center items-center">
        <Image src={'/images/favicons/loading.gif'} alt={'loading'} width={50} height={50} />
      </div>
    )
  }

  return hits.length > 0 ? (
    <Hits
      hitComponent={AdvancedSearch}
      classNames={{
        root: '',
        list: 'flex flex-wrap justify-center sm:-ml-7',
      }}
    />
  ) : (
    showNoResults && <NoResults />
  )
}
